/** @format */

export enum Colors {
  customGray = "#6f6f65",
  customYellow = "#fbfbd2",
  customBlue = "#0066CC",
}
